export default "__VITE_ASSET__65998c72__"